export const STAKING_ABI = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "_pilIn",
                type: "uint128",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "_xPilOut",
                type: "uint128",
            },
        ],
        name: "Enter",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "_xPilIn",
                type: "uint128",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "_pilOut",
                type: "uint128",
            },
        ],
        name: "Leave",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "uint128",
                name: "_amount",
                type: "uint128",
            },
        ],
        name: "enter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_holder",
                type: "address",
            },
        ],
        name: "getLockedAmount",
        outputs: [
            {
                internalType: "uint128",
                name: "_lockedAmount",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_holder",
                type: "address",
            },
        ],
        name: "getUnlockedAmount",
        outputs: [
            {
                internalType: "uint128",
                name: "_unlockedAmount",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint128",
                name: "_share",
                type: "uint128",
            },
        ],
        name: "leave",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
